import {
  TAB_MAPPER,
  CLINIC_ROLES,
  EVOKE_ACTIVE,
  CLINIC_ACTIVE,
  HF_BILLING_CODES,
  MANUFACTURER_MAPPER,
  CLINIC_REPORT_STATES,
} from "static/constants";

export const convertBytesToMB = (bytes) => {
  const sizeInMB = (bytes / (1024 * 1024)).toFixed(2);
  return sizeInMB;
};

export const createFormData = (payload) => {
  const formData = new FormData();
  for (const key in payload) {
    const value = payload[key];
    formData.append(key, value);
  }
  return formData;
};

export const getReportCurrentTab = (reportObject) => {
  const {
    evk_active,
    evk_archived,
    evk_processed,
    clinic_active,
    clinic_processed,
    clinic_for_review,
  } = reportObject || {};

  if (evk_active) return TAB_MAPPER.evk_active;
  if (clinic_active) return TAB_MAPPER.clinic_active;
  if (clinic_for_review) return TAB_MAPPER.clinic_for_review;
  if (clinic_processed) return TAB_MAPPER.clinic_processed;
  if (evk_processed || evk_archived) return TAB_MAPPER.evk_processed;

  return "";
};

export const getInitialReportTab = ({
  rowData,
  reportAccountDetail,
  isReportOfAllowedBillingCode,
}) => {
  const { billing_code, createdBy, patient, manufacturer, initial_tab } =
    rowData || {};

  const isHF = HF_BILLING_CODES.includes(billing_code);
  const patientInitialTab = patient?.initial_report_tab;
  const patientReportTab =
    TAB_MAPPER[isHF ? patientInitialTab?.hf : patientInitialTab?.regular];

  if (patientReportTab) return patientReportTab;

  const isClinicUploader =
    CLINIC_ROLES.includes(createdBy?.role) ||
    CLINIC_REPORT_STATES.includes(initial_tab);

  const isAllowedClinicUploader =
    isClinicUploader && isReportOfAllowedBillingCode;

  if (isAllowedClinicUploader) return CLINIC_ACTIVE;

  const accountInitialTab =
    reportAccountDetail?.settings?.manufacturer?.[
      MANUFACTURER_MAPPER[manufacturer]
    ]?.initial_report_tab;

  const accountReportTab =
    TAB_MAPPER[isHF ? accountInitialTab?.hf : accountInitialTab?.regular];

  if (!isAllowedClinicUploader && accountReportTab === EVOKE_ACTIVE) {
    return EVOKE_ACTIVE;
  }

  return accountReportTab || EVOKE_ACTIVE;
};

export const validateEmail = (email) => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
};

export const generateDistinctColors = (count) => {
  const colors = [
    "#5489D8",
    "#FE9859",
    "#9B6AD7",
    "#A1A1A1",
    "#FFBB37",
    "#134DAA",
    "#FF6B6B",
    "#4ECDC4",
    "#45B7D1",
    "#96CEB4",
    "#FFEAA7",
    "#DDA0DD",
    "#98D8C8",
    "#F7DC6F",
    "#BB8FCE",
    "#85C1E9",
    "#F8C471",
    "#82E0AA",
    "#F1948A",
    "#AED6F1",
  ];

  if (count <= colors.length) {
    return colors.slice(0, count);
  }

  const additionalColors = [];
  for (let i = colors.length; i < count; i++) {
    const hue = (i * 137.508) % 360;
    additionalColors.push(`hsl(${hue}, 70%, 60%)`);
  }

  return [...colors, ...additionalColors];
};
